<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>67_date-LIGHT</title>
    <path
      fill="#679940"
      class="cls-1"
      d="M60,6H56V0H52V6H12V0H8V6H4a4,4,0,0,0-4,4V60a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4V10A4,4,0,0,0,60,6Zm0,54H4V20H60ZM4,16V10H8v4h4V10H52v4h4V10h4v6Z"
    />
    <rect fill="#679940" class="cls-1" x="20" y="35" width="10" height="10" />
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/CalendarIcon.vue